var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"385.71","cy":"385.71","r":"385.71","style":{"fill":"#1d5377"},"key":0}),React.createElement("polygon",{"points":"575.39 293.4 561.01 275.58 293.25 491.48 214.07 393.28 196.04 407.82 289.6 523.85 307.63 509.31 307.63 509.31 575.39 293.4","style":{"fill":"#fff","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"55px"},"key":1})]);
}

CheckmarkInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 771.43 771.43"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
